import React from 'react';
import ReactDOM from 'react-dom';
import { App } from '@root/src/web/components/App';
import { ABProvider } from '@guardian/ab-react';
import { tests } from '@frontend/web/experiments/ab-tests';
import { getCookie } from '../browser/cookie';
export const HydrateApp = ({ CAPI, NAV }) => {
    const mvtId = Number((CAPI.config.isDev && getCookie('GU_mvt_id_local')) || // Simplify localhost testing by creating a different mvt id
        getCookie('GU_mvt_id'));
    if (!mvtId) {
        // 0 is default and falsy here
        // eslint-disable-next-line no-console
        console.log('There is no MVT ID set, see HydrateApp.tsx');
    }
    const ophanRecordFunc = window &&
        window.guardian &&
        window.guardian.ophan &&
        window.guardian.ophan.record;
    ReactDOM.render(React.createElement(ABProvider, { arrayOfTestObjects: tests, abTestSwitches: {
            ...{ abAbTestTest: true },
            ...CAPI.config.switches,
        }, pageIsSensitive: CAPI.config.isSensitive, mvtMaxValue: 1000000, mvtId: mvtId, ophanRecord: ophanRecordFunc },
        React.createElement(App, { CAPI: CAPI, NAV: NAV })), document.getElementById('react-root'));
};
